export default __webpack_public_path__ + "static/g203-ae7b863fbd0e285dccc8f334936d760b.jpg";